export default class AgentLoginAction {
  constructor(agentId, password) {
    this.agentId = agentId;
    this.client = 'agent-' + agentId;
    this.password = password;
    this.action = 'AgentLoginAction';
    this.voice = true;
    this.chat = true;
    this.whatsApp = true;
    this.facebook = true;

    console.log('Enviando informações de login:', this);
  }
}
